import { COLORS } from '@/styles/colors';
import { media } from '@/styles/responsive';
import { THEME } from '@/styles/theme';
import styled from 'styled-components';
import { SwitchRoleButtonWrapper } from '../Sidebar/ui/SwitchRoleButton/styles';
import { bodySmall, poppinsMediumFont } from '@/styles/typography';

export const CookiesBannerWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${COLORS.grey[900]};
  padding: 24px 28px;
  border-radius: 12px;
  width: 624px;
  bottom: 30px;
  z-index: ${THEME.modal.zIndex};

  ${media.mobile`
    padding: 20px;
    width: auto;
    left: 16px;
    right: 16px;
    transform: none;
  `}
`;

export const PrivacyPolicyLink = styled.a`
  ${poppinsMediumFont};
  color: ${COLORS.green[350]};
  text-decoration: none;
  ${bodySmall};

  &:hover {
    text-decoration: underline;
  }
`;

export const ManagePreferencesButton = styled(SwitchRoleButtonWrapper)``;

export const CookiesBannerButtonGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;

  ${media.mobile`
    grid-template-columns: repeat(1, minmax(0px, 1fr));
    gap: 12px;
    flex-direction: column-reverse;

    & > :last-child {
      order: -1;
    }
  `}
`;
